module.exports = __webpack_public_path__ + "static/media/cylinder_cover_blue.4effa0a1.png";